import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../../../../../shared/_services/employee.service';

@Component({
  selector: 'app-employee-exchange-benefits',
  templateUrl: './employee-exchange-benefits.component.html',
  styleUrls: ['./employee-exchange-benefits.component.scss']
})
export class EmployeeExchangeBenefitsComponent implements OnInit {
  employeeId: any;
  constructor(
    private employeeService: EmployeeService
  ) { }

  ngOnInit() {
    this.employeeId = this.employeeService.employeeId;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/employee-exchange-benefits/employee-exchange-benefits.component.ts